import { useAction, useAtom } from "@reatom/npm-react";
import { PaymentSubscribeRequestDto } from "definitions/poizon-bff";
import { useEffect, useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { trackEvent } from "src/util/analytics.ts";

import {
  getSubscribePriceRequest,
  getSubscribePriceRequestWithDebouncing,
} from "../store/fetchers/getSubscribePrice";
import { calculateMaxRequests } from "../util";

export const useSubscribe = (
  form: UseFormReturn<PaymentSubscribeRequestDto>,
) => {
  const { watch, setValue } = form;
  const [rps, req, type, withExport] = watch([
    "rps",
    "req",
    "type",
    "withExport",
  ]);

  const [subscribePrice] = useAtom(getSubscribePriceRequest.dataAtom);
  const [isLoadingPrice] = useAtom(getSubscribePriceRequest.isLoadingAtom);
  const fetchSubscribePrice = useAction(getSubscribePriceRequestWithDebouncing);

  const isUnlimited = useMemo(
    () => calculateMaxRequests(rps) === req,
    [req, rps],
  );

  const isDisabledExport = isUnlimited || rps < 1;

  /* eslint-disable react-you-might-not-need-an-effect/no-event-handler, react-you-might-not-need-an-effect/no-pass-data-to-parent -- антипаттерн, но SubscribePageDeprecated выведена из активной поддержки — синки формы не трогаем */
  useEffect(() => {
    const maxRequests = calculateMaxRequests(rps);
    if (req && maxRequests < req) {
      setValue("req", maxRequests);
    }
    if (rps < 1) {
      setValue("withExport", false);
    }
  }, [rps, req, setValue]);

  useEffect(() => {
    if (isDisabledExport) {
      setValue("withExport", false);
    }
  }, [isDisabledExport, setValue]);
  /* eslint-enable react-you-might-not-need-an-effect/no-event-handler, react-you-might-not-need-an-effect/no-pass-data-to-parent */

  // Отслеживаем просмотр страницы тарифов
  useEffect(() => {
    trackEvent("tariff_page_viewed", {
      rps,
      req,
      withExport,
    });
  }, [rps, req, withExport]);

  useEffect(() => {
    fetchSubscribePrice({
      type: type,
      rps,
      requestCount: req ?? 0,
      withExport,
    });
  }, [fetchSubscribePrice, rps, req, type, withExport]);

  return {
    isDisabledExport,
    price: subscribePrice,
    isLoadingPrice,
  };
};
